export default __webpack_public_path__ + "static/media/cv.97b7f26d.png";